import React from "react";

import {
  Carousel,
  CarouselApi,
  CarouselContent,
  CarouselItem,
} from "@/components/ui";
import {
  OnboardingStepDesktop1,
  OnboardingStep2,
  OnboardingStep3,
  OnboardingStepMobile1,
} from "./Steps";

export const steps = [
  {
    title: "Welcome to dripit!",
    description: `Here you can predict which artists will get more Spotify plays and earn rewards for your music insights.`,
    mobileComponent: <OnboardingStepMobile1 />,
    desktopComponent: <OnboardingStepDesktop1 />,
  },
  {
    title: "Welcome to dripit!",
    description: `Here you can predict which artists will get more Spotify plays and earn rewards for your music insights.`,
    mobileComponent: <OnboardingStep2 variant="mobile" />,
    desktopComponent: <OnboardingStep2 variant="desktop" />,
  },
  {
    title: "Money in & out",
    description: "Let's start predicting!",
    mobileComponent: <OnboardingStep3 variant="mobile" />,
    desktopComponent: <OnboardingStep3 variant="desktop" />,
  },
];

interface OnboardingCarouselProps {
  useDesktopCarousel?: boolean;
  setCarouselApi: (api: CarouselApi) => void;
}

export const OnboardingCarousel: React.FC<OnboardingCarouselProps> = ({
  useDesktopCarousel = false,
  setCarouselApi,
}) => (
  <Carousel setApi={setCarouselApi}>
    <CarouselContent className="!ml-0 w-full">
      {steps.map(({ mobileComponent, desktopComponent }, index) => (
        <CarouselItem key={index} className="w-full max-w-full">
          <div className="h-full w-full">
            {useDesktopCarousel ? desktopComponent : mobileComponent}
          </div>
        </CarouselItem>
      ))}
    </CarouselContent>
  </Carousel>
);
